/** index.html :root と完全一致させた既定値 */
export const BASE_CSS_VARS = {
  "--primary": "#10B981",
  "--primary-dark": "#059669",
  "--primary-light": "#C8F5E0",
  "--primary-ultra": "#F0FDF9",
  "--accent": "#F59E0B",
  "--accent-light": "#FEF3C7",
  "--error": "#EF4444",
  "--error-light": "#FEE2E2",
  "--bg": "#ECEEF2",
  "--surface": "#FFFFFF",
  "--border": "#DDE1E7",
  "--border-light": "#ECEEF2",
  "--text": "#20242B",
  "--text-secondary": "#606976",
  "--text-muted": "#77818E",
  "--shadow-sm": "0 1px 2px rgba(0,0,0,0.05), 0 1px 3px rgba(0,0,0,0.06)",
  "--shadow": "0 4px 12px rgba(0,0,0,0.08), 0 2px 4px rgba(0,0,0,0.04)",
  "--shadow-lg": "0 8px 24px rgba(0,0,0,0.10), 0 2px 6px rgba(0,0,0,0.04)",
  "--r-card": "16px",
  "--r-btn": "9999px",
  "--r-input": "10px",
  "--ink-accent": "#087F63",
  "--app-gradient": "linear-gradient(135deg, #10B981 0%, #059669 50%, #34d399 100%)"
};

export const STORAGE_KEY_APPEARANCE = 'nihongo-appearance-bg';

/** 背景まわりを差し替えるプリセット（必要な変数だけ上書き） */
export const BACKGROUND_PRESETS = [
  {
    id: 'mint',
    label: 'ミント',
    hint: 'デフォルト',
    themeColor: '#10B981',
    vars: {},
  },
  {
    id: 'cream',
    label: 'クリーム',
    hint: '暖かい白',
    themeColor: '#F59E0B',
    vars: {
      '--bg': '#FFFBF0',
      '--surface': '#FFFFFF',
      '--border-light': '#F5F0E6',
      '--primary-ultra': '#FFFBEB',
    },
  },
  {
    id: 'sky',
    label: 'スカイ',
    hint: '淡い青',
    themeColor: '#0EA5E9',
    vars: {
      '--bg': '#E0F2FE',
      '--surface': '#FFFFFF',
      '--border-light': '#E8F4FC',
      '--primary-light': '#BAE6FD',
      '--primary-ultra': '#F0F9FF',
    },
  },
  {
    id: 'lavender',
    label: 'ラベンダー',
    hint: '淡い紫',
    themeColor: '#8B5CF6',
    vars: {
      '--bg': '#F3E8FF',
      '--surface': '#FFFFFF',
      '--border-light': '#EDE9FE',
      '--primary-ultra': '#FAF5FF',
    },
  },
  {
    id: 'paper',
    label: 'ペーパー',
    hint: '紙のようなベージュ',
    themeColor: '#78716C',
    vars: {
      '--bg': '#F5F0E8',
      '--surface': '#FFFCF7',
      '--border': '#E7E2DA',
      '--border-light': '#EFEAE3',
      '--primary-ultra': '#FAF7F2',
    },
  },
  {
    id: 'dusk',
    label: 'ダスク',
    hint: 'ダーク',
    themeColor: '#0F172A',
    vars: {
      '--bg': '#0F172A',
      '--surface': '#1E293B',
      '--border': '#334155',
      '--border-light': '#334155',
      '--text': '#F8FAFC',
      '--text-secondary': '#CBD5E1',
      '--text-muted': '#94A3B8',
      '--primary-light': 'rgba(16,185,129,0.28)',
      '--primary-ultra': 'rgba(16,185,129,0.12)',
      '--shadow-sm': '0 1px 4px rgba(0,0,0,0.25)',
      '--shadow': '0 4px 16px rgba(0,0,0,0.35)',
      '--shadow-lg': '0 8px 32px rgba(0,0,0,0.45)',
    },
  },
];

export function getPresetById(id) {
  return BACKGROUND_PRESETS.find(p => p.id === id) || BACKGROUND_PRESETS[0];
}

export function readStoredBackgroundId() {
  try {
    const v = localStorage.getItem(STORAGE_KEY_APPEARANCE);
    if (v && BACKGROUND_PRESETS.some(p => p.id === v)) return v;
  } catch (_) {
    /* ignore */
  }
  return 'mint';
}

export function writeStoredBackgroundId(id) {
  try {
    localStorage.setItem(STORAGE_KEY_APPEARANCE, id);
  } catch (_) {
    /* ignore */
  }
}

export function applyBackgroundPresetToDocument(presetId) {
  const preset = getPresetById(presetId);
  const root = document.documentElement;
  root.dataset.appearance = preset.id;
  const merged = { ...BASE_CSS_VARS, ...preset.vars };
  Object.entries(merged).forEach(([key, value]) => {
    root.style.setProperty(key, value);
  });
  const meta = document.querySelector('meta[name="theme-color"]');
  if (meta) meta.setAttribute('content', preset.themeColor);
}
